import { DisplayObject } from './DisplayObject';

/** flash.display.InteractiveObject. */
export class InteractiveObject extends DisplayObject {
  /** @internal */ $mouseEnabled: boolean;
  /** @internal */ $doubleClickEnabled: boolean;
  /** @internal */ $tabEnabled: boolean | null;
  /** @internal */ $tabIndex: number;
  /** @internal */ $focusRect: any;
  /** @internal */ $contextMenu: any;

  constructor() {
    super();
    this.$mouseEnabled = true;
    this.$doubleClickEnabled = false;
    this.$tabEnabled = null;
    this.$tabIndex = -1;
    this.$focusRect = null;
    this.$contextMenu = null;
  }

  /** @internal */ get $isInteractive(): boolean {
    return true;
  }

  get mouseEnabled(): boolean {
    return this.$mouseEnabled;
  }
  set mouseEnabled(v: boolean) {
    this.$mouseEnabled = !!v;
  }
  get doubleClickEnabled(): boolean {
    return this.$doubleClickEnabled;
  }
  set doubleClickEnabled(v: boolean) {
    this.$doubleClickEnabled = !!v;
  }
  get tabEnabled(): boolean {
    return this.$tabEnabled ?? false;
  }
  set tabEnabled(v: boolean) {
    this.$tabEnabled = !!v;
  }
  get tabIndex(): number {
    return this.$tabIndex;
  }
  set tabIndex(v: number) {
    this.$tabIndex = v | 0;
  }
  get focusRect(): any {
    return this.$focusRect;
  }
  set focusRect(v: any) {
    this.$focusRect = v;
  }
  /** Context menus are a host feature; the value is stored but never shown (VK menu removed). */
  get contextMenu(): any {
    return this.$contextMenu;
  }
  set contextMenu(v: any) {
    this.$contextMenu = v;
  }
}
